import React from 'react';
import Modal from 'react-modal';
import './EntityDetailModal.css';

Modal.setAppElement('#root');

interface EntityDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'category' | 'vendor' | 'shop';
  data: any | null;
}

const EntityDetailModal: React.FC<EntityDetailModalProps> = ({
  isOpen,
  onClose,
  type,
  data,
}) => {
  const renderContent = () => {
    if (!data) return <p className="entity-loading">Loading...</p>;

    switch (type) {
      case 'category':
        return (
          <>
            <h2 className="entity-title">Category Details</h2>
            <p><strong>ID:</strong> {data.id}</p>
            <p><strong>Name:</strong> {data.name}</p>
            <p><strong>Slug:</strong> {data.slug}</p>
          </>
        );
      case 'vendor':
        return (
          <>
            <h2 className="entity-title">Vendor Details</h2>
            <p><strong>ID:</strong> {data.id}</p>
            <p><strong>Business Name:</strong> {data.businessName}</p>
            <p><strong>Email:</strong> {data.email}</p>
            <p><strong>Phone:</strong> {data.phone}</p>
            <p><strong>Address:</strong> {data.address}</p>
          </>
        );
      case 'shop':
        return (
          <>
            <h2 className="entity-title">Shop Details</h2>
            <p><strong>ID:</strong> {data.id}</p>
            <p><strong>Shop Name:</strong> {data.shopName}</p>
            <p><strong>Location:</strong> {data.location}</p>
          </>
        );
      default:
        return null;
    }
  };


  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Entity Details">
      <button onClick={onClose} style={{ float: 'right' }}>❌</button>
      {renderContent()}
    </Modal>
  );
};

export default EntityDetailModal;
